import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ProductCard from '../components/ProductCard';
import FadeIn from '../components/FadeIn';
import allProducts from '../data/products.json';

const CATEGORY_DATA = {
  elektromos: {
    slug: 'elektromos',
    title: 'Elektromos Kerékpár',
    titleSEO: 'Elektromos Kerékpár Baja – E-bike Webáruház | Cruiser Shop',
    description: 'Elektromos kerékpárok és e-bike-ok széles választéka Baján. Pedelec, city e-bike, trekking elektromos kerékpár nálunk Baján. Személyes beüzemelés, szakértő tanácsadás.',
    h1: 'Elektromos Kerékpár – E-bike Webáruház Baja',
    intro: 'Az elektromos kerékpár (e-bike) forradalmasítja a közlekedést: dombos terepen, munkába menet vagy hosszabb túrákon is könnyedén haladsz motoros segítséggel. A Cruiser Shop kínálatában 24 elektromos kerékpár modell közül választhatsz — pedelec rendszerűektől a city e-bike-okig. Minden elektromos bringát személyesen beüzemelünk és bemutatjuk a kezelését.',
    sections: [
      {
        h2: 'Miért válassz elektromos kerékpárt?',
        text: 'Az e-bike ideális ha naponta 10–50 km-t tennél meg kényelemesen, nem szeretnél izzadva érkezni munkahelyre, vagy dombos területen laksz. A 250W-os motorral akár 80 km hatótávot is elérhetsz egy töltéssel. Baja és Bács-Kiskun megye sík terepe különösen alkalmas elektromos bringázáshoz.',
      },
      {
        h2: 'Elektromos kerékpár típusok a kínálatunkban',
        text: 'City e-bike: városi közlekedésre, csomagtartóval és sárfogóval. Trekking e-bike: hosszabb túrákhoz, erősebb akkumulátorral. Pedelec: hajtásarányos motorral, természetes bringás érzéssel. Minden modellnél megtalálod a motor teljesítményét, az akkumulátor kapacitását és a hatótávot.',
      },
      {
        h2: 'Elektromos kerékpár szerviz Baján',
        text: 'Nem csak eladjuk, de szerviszelünk is! Akkumulátor csere, motor karbantartás, szoftver frissítés — mindezt Baján, gyorsan elvégezzük. Leggyakrabban még aznap kész a szerviz.',
      },
    ],
    faqs: [
      { q: 'Mennyi az elektromos kerékpár hatótávja?', a: 'Átlagosan 50–80 km töltésenként, de ez függ a tereptől, a rakománytól és a motor segítség szintjétől.' },
      { q: 'Szükséges-e jogosítvány az e-bike-hoz?', a: 'Nem, a 250W-os pedelec e-bike-okhoz Magyarországon nem kell jogosítvány, biztosítás vagy rendszám.' },
      { q: 'Mennyi ideig tart az elektromos kerékpár töltése?', a: 'Általában 3–5 óra a teljes töltés, néhány modellnél gyorstöltő opcióval 2 óra alatt is kész.' },
      { q: 'Kapok garanciát az elektromos kerékpárra?', a: 'Igen, minden elektromos kerékpárra 2 év gyártói garanciát adunk, a motorra és az akkumulátorra is.' },
    ],
    related: [
      { slug: 'tura-kerekpar', label: 'Túrakerékpár' },
      { slug: 'varosi-kerekpar', label: 'Városi kerékpár' },
    ],
    shopKategoria: 'elektromos',
    color: '#818cf8',
    bg: '#1A1A3E',
  },
  tura: {
    slug: 'tura',
    title: 'Túrakerékpár',
    titleSEO: 'Túrakerékpár Baja – Trekking Kerékpár Webáruház | Cruiser Shop',
    description: 'Túrakerékpárok és trekking bringák széles választéka Baján. 90+ modell, személyes beüzemelés, szakértő tanácsadás. Cruiser Shop kerékpárüzlet.',
    h1: 'Túrakerékpár – Trekking Bringák Baja',
    intro: 'A túrakerékpár (trekking bike) a legsokrétűbb kerékpár kategória: egyaránt alkalmas városban, aszfalton és könnyebb terepen is. A Cruiser Shop kínálatában 90-nél is több trekking modell várja vevőinket Baján és az egész Bács-Kiskun megyéből. Robusztus váz, kényelmes ülés, csomagtartó és sárvédő — minden megvan amit egy hosszabb túrához el kell vinned.',
    sections: [
      {
        h2: 'Miért jó a túrakerékpár?',
        text: 'A trekking kerékpár ideális ha változatos terepen közlekedsz, távolabb is elmennél (50–200 km-es túrák), hétvégi kirándulásokhoz, vagy strapabíró, megbízható bringát keresel. A Cruiser Shop-nál minden korosztálynak és igénynek megfelelő modellt megtalálsz.',
      },
      {
        h2: 'Túrakerékpár márkák a Cruiser Shop-nál',
        text: 'Kínálatunkban megtalálod a legismertebb európai és ázsiai gyártók trekking modelljeit. Férfi, női és unisex vázakban, 26"-os és 28"-os kerékméretben, 21-27 fokozatú váltóval. A minőség és az ár egyensúlya garantált.',
      },
      {
        h2: 'Túrakerékpár szerviz és felszerelés',
        text: 'Trekking kerékpárhoz csomagtartót, táskákat, reflektorokat és egyéb kiegészítőket is értékesítünk üzletünkben Baján. Szerviz: gumicsere, lánc csere, váltó és fékbeállítás gyorsan, szakszerűen.',
      },
    ],
    faqs: [
      { q: 'Mi a különbség a túra és a városi kerékpár között?', a: 'A túrakerékpár erősebb, terepre is alkalmas, általában csomagtartóval és sárvédővel jön. A városi bringánál a könnyedség és a dizájn dominál.' },
      { q: 'Mekkora kerékméret kell túrakerékpárhoz?', a: 'Felnőtteknek általában 28 col az ideális útkerékpárhoz, de magasságtól függően 26 col is szóba jöhet.' },
      { q: 'Hány fokozatú váltóval érdemes túrakerékpárt venni?', a: 'Sík terepen 21 fokozat is elegendő, de dombos vidékre 27 fokozatos váltót ajánlunk.' },
    ],
    related: [
      { slug: 'elektromos-kerekpar', label: 'Elektromos kerékpár' },
      { slug: 'mtb-kerekpar', label: 'MTB kerékpár' },
    ],
    shopKategoria: 'tura',
    color: '#4ade80',
    bg: '#0D3320',
  },
  mtb: {
    slug: 'mtb',
    title: 'MTB Kerékpár',
    titleSEO: 'MTB Kerékpár Baja – Mountain Bike Webáruház | Cruiser Shop',
    description: 'MTB és mountain bike kerékpárok széles választéka Baján. 68 modell, terepkerékpár minden korosztálynak. Személyes beüzemelés, szakértő tanácsadás.',
    h1: 'MTB Kerékpár – Mountain Bike Baja',
    intro: 'A mountain bike (MTB) a terepkerékpározás királya: erdei ösvényeken, kavicsos utakon és dombos terepen egyaránt otthon van. A Cruiser Shop MTB kínálatában 68 modell közül választhatsz — hardtail és fully kivitelben, 26"-os, 27.5"-os és 29"-os kerékméretben. Bajáról és Bács-Kiskun megyéből is sokan keresnek minket MTB kerékpárért.',
    sections: [
      {
        h2: 'Hardtail vagy fully MTB — melyiket válasszam?',
        text: 'Hardtail: csak első amortizátora van, könnyebb, olcsóbb, ideális kezdőknek és könnyebb terepen. Fully (full suspension): első és hátsó amortizátor is van, drágább de sokkal kényelmesebb nehéz tereppen. Ha most kezded az MTB-t, a hardtail a legjobb választás.',
      },
      {
        h2: 'MTB kerékméret választás',
        text: '26 col: kisebb termetűeknek és trükkösebb manőverekhez. 27.5 col (650B): kompromisszum, sokoldalú. 29 col: nagy kerék, gyorsabb gördülés, ideális magasabb termetűeknek és hosszabb túrákhoz. A Cruiser Shop-ban személyesen segítünk megtalálni a számodra ideális méretet.',
      },
      {
        h2: 'MTB szerviz Baján',
        text: 'Amortizátor szerviz, fékbetét csere, lánc és hajtómű karbantartás — MTB szervizzel is várjuk a vevőinket. Sok esetben még aznap kész a munka.',
      },
    ],
    faqs: [
      { q: 'Mennyi az MTB kerékpár ára a Cruiser Shop-nál?', a: 'MTB kerékpáraink 50.000 Ft-tól 300.000 Ft-ig terjednek, a minőségtől és a felszereltségtől függően.' },
      { q: 'Lehet MTB-vel közlekedni városban is?', a: 'Igen, de a vastag gumi miatt lassabb az aszfalton. Ha főleg városban használnád, inkább trekking vagy városi bringát ajánlunk.' },
      { q: 'Milyen MTB kerékpárt ajánlotok kezdőknek?', a: 'Kezdőknek egy jó minőségű hardtail MTB-t ajánlunk 21-27 fokozatú Shimano váltóval, 100mm amortizátorral.' },
    ],
    related: [
      { slug: 'tura-kerekpar', label: 'Túrakerékpár' },
      { slug: 'elektromos-kerekpar', label: 'Elektromos kerékpár' },
    ],
    shopKategoria: 'mtb',
    color: '#86efac',
    bg: '#1C2D0A',
  },
  varosi: {
    slug: 'varosi',
    title: 'Városi Kerékpár',
    titleSEO: 'Városi Kerékpár Baja – City Bike Webáruház | Cruiser Shop',
    description: 'Városi kerékpárok és city bike-ok széles választéka Baján. 120+ modell, férfi, női és unisex kivitelben. Személyes beüzemelés, szakértő tanácsadás.',
    h1: 'Városi Kerékpár – City Bike Baja',
    intro: 'A városi kerékpár a mindennapi közlekedés legjobb eszköze: könnyű, kényelmes, stílusos. A Cruiser Shop kínálatában több mint 120 city bike modell közül választhatsz Baján — férfi, női és unisex kivitelben, agyváltóval vagy külső fogaskerékkel. Legyen szó munkába járásról, bevásárlásról vagy hétvégi kör tekerésről, megtalálod a tökéletes városi bringát nálunk.',
    sections: [
      {
        h2: 'Városi kerékpár jellemzők',
        text: 'A city bike-ok jellemzői: könnyű alumínium váz, kényelmes, egyenes kormány, sárvédő és csomagtartó, 1-8 fokozatú váltó vagy agyváltó, dinamós világítás. Ideális Baja sík utcáin és kerékpáros ösvényein.',
      },
      {
        h2: 'Városi kerékpár nőknek és férfiaknak',
        text: 'Kínálatunkban külön férfi és női modellek is elérhetők — a váz magassága, geometriája és a dizájn mind igazodik az igényekhez. Tanácstalan vagy? Üzletünkben személyesen segítünk megtalálni a méreteidnek megfelelő bringát.',
      },
      {
        h2: 'Városi bringás kiegészítők',
        text: 'Lakat, kosár, nyereg táska, gyerekülés, pumpa, sisak — minden kiegészítőt megtalálsz a Cruiser Shop üzletében Baján. Nem csak kerékpárt, hanem komplett kerékpáros felszerelést is biztosítunk.',
      },
    ],
    faqs: [
      { q: 'Melyik a legjobb városi kerékpár Baján?', a: 'Baja sík területe miatt 1–3 fokozatú agyváltós city bike is elegendő, de ha Bács-Kiskun más részébe is mész, 7–8 fogaskerékkel jobb.' },
      { q: 'Kell-e sárvédő a városi kerékpárra?', a: 'Erősen ajánlott, különösen ha munkába jársz bringával. Legtöbb city bike modellünkön alapfelszereltség.' },
      { q: 'Milyen korúak vehetnek városi kerékpárt?', a: 'Tinédzserektől idősekig mindenki — van kiskerekes, alacsony belépős és stepperes kivitel is.' },
    ],
    related: [
      { slug: 'elektromos-kerekpar', label: 'Elektromos kerékpár' },
      { slug: 'tura-kerekpar', label: 'Túrakerékpár' },
    ],
    shopKategoria: 'varosi',
    color: '#fb923c',
    bg: '#7C1D0D',
  },
  gyermek: {
    slug: 'gyermek',
    title: 'Gyermek Kerékpár',
    titleSEO: 'Gyermek Kerékpár Baja – Gyerek Bringák Webáruháza | Cruiser Shop',
    description: 'Gyermek kerékpárok 12–24 colig Baján. 80 modell, segédkerekekkel vagy anélkül. Személyes beüzemelés, szakértő tanácsadás. Cruiser Shop kerékpárüzlet.',
    h1: 'Gyermek Kerékpár – Gyerek Bringák Baja',
    intro: 'A Cruiser Shop Baján a legnagyobb gyermekkerékpár választékkal rendelkező üzlet Bács-Kiskun megyében. 80 gyerek kerékpár modell közül választhatsz 12 colos beginner bringáktól 24 colos ifjúsági modellekig. Segédkerekekkel (tanulókerékkel) és anélkül is, fiúknak és lányoknak, minden korosztálynak. Minden bringát beállítunk a gyerek testmagasságához.',
    sections: [
      {
        h2: 'Mekkora gyermek kerékpárt vegyek?',
        text: '12 col: 2–4 éves (95–110 cm). 16 col: 4–6 éves (105–120 cm). 20 col: 6–9 éves (115–135 cm). 24 col: 9–13 éves (130–150 cm). 26 col: 13+ éves. Üzletünkben személyesen segítünk megmérni és kiválasztani a megfelelő méretet.',
      },
      {
        h2: 'Gyerek kerékpár biztonsági funkciók',
        text: 'A gyermek bringákon különös figyelmet fordítunk a biztonságra: visszafogó fék (pedálgátló), jól beállítható V-fék, stabil váz, tüskementes vagy tömör gumi opció. Minden kerékpárhoz ajánlott bukósisak is kapható üzletünkben.',
      },
      {
        h2: 'Mikor vegyünk segédkerekest?',
        text: 'A segédkerekek 2–5 éves korig ajánlottak, utána célszerű futóbringán vagy segédkerekek nélkül tanítani az egyensúlyt. A Cruiser Shop-nál mindkét megoldáshoz találsz megfelelő bringát.',
      },
    ],
    faqs: [
      { q: 'Mikor tanuljon meg bringázni a gyerek?', a: 'Az első futóbringát 18 hónapos kortól lehet bevezetni. Pedálos kerékpárt 3–4 éves kortól ajánlunk.' },
      { q: 'Kell-e sisak a gyerek kerékpározáshoz?', a: 'Törvény szerint 14 éves korig kötelező bukósisakban kerékpározni. Minden vásárláshoz segítünk megfelelő sisakot kiválasztani.' },
      { q: 'Mennyi ideig jó egy gyerek kerékpár?', a: 'Általában 2–3 évig, amíg a gyerek ki nem nőtte. Ezért érdemes egy kicsit nagyobb méretet venni, amit fel lehet állítani.' },
    ],
    related: [
      { slug: 'varosi-kerekpar', label: 'Városi kerékpár' },
      { slug: 'haromkereku-kerekpar', label: 'Háromkerekű kerékpár' },
    ],
    shopKategoria: 'gyermek',
    color: '#fbbf24',
    bg: '#7A3A00',
  },
  haromkereku: {
    slug: 'haromkereku',
    title: 'Háromkerekű Kerékpár',
    titleSEO: 'Háromkerekű Kerékpár Baja – Tricikli Felnőtteknek | Cruiser Shop',
    description: 'Háromkerekű kerékpárok és triciklik felnőtteknek Baján. Stabil, kényelmes megoldás időseknek és egyensúlyi problémákkal élőknek.',
    h1: 'Háromkerekű Kerékpár – Tricikli Felnőtteknek Baja',
    intro: 'A háromkerekű kerékpár (tricikli) tökéletes megoldás azoknak, akik egyensúlyi problémák, mozgáskorlátozottság vagy idős kor miatt nem tudnak hagyományos kétkerekű bringán biztonságosan közlekedni. A Cruiser Shop kínálatában 6 háromkerekű kerékpár modell közül választhatsz — mindegyik stabil, kényelmes és Baján, nálunk személyesen is kipróbálható.',
    sections: [
      {
        h2: 'Kinek ajánlott a háromkerekű kerékpár?',
        text: 'Időseknek, akik biztonságosan szeretnének közlekedni. Mozgáskorlátozottaknak és rehabilitáló pácienseknek. Azoknak, akiknek egyensúlyi problémájuk van. Bevásárláshoz — a legtöbb modellnek nagy csomagtartó kosara van hátul.',
      },
      {
        h2: 'Háromkerekű kerékpár jellemzők',
        text: 'Erős acél vagy alumínium váz, kényelmes, széles nyereg, alacsony belépési pont (könnyű fel- és leszállás), hátsó csomagtartó kosár, 1–7 fokozatú váltó. Egyes modellek elektromos meghajtással is elérhetők.',
      },
    ],
    faqs: [
      { q: 'Nehéz-e megtanulni háromkerekű kerékpáron közlekedni?', a: 'A kanyarodás igényel némi szokást (más mint a kétkerekűn), de az egyensúlyozás automatikus, így legtöbben gyorsan megszokják.' },
      { q: 'Mekkora terhelhetőségű háromkerekű kerékpárt ajánlotok?', a: 'Modelljeinktől függően 100–150 kg terhelhetőség. Érdeklődjön üzletünkben a konkrét adatokért.' },
    ],
    related: [
      { slug: 'varosi-kerekpar', label: 'Városi kerékpár' },
      { slug: 'gyermek-kerekpar', label: 'Gyermek kerékpár' },
    ],
    shopKategoria: 'haromkereku',
    color: '#c084fc',
    bg: '#2C1654',
  },
};

export default function CategoryLanding({ category }) {
  const data = CATEGORY_DATA[category];
  const products = allProducts.filter(p => p.category_slug === data.shopKategoria).slice(0, 8);
  const loading = false;

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: data.faqs.map(f => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Kezdőlap', item: 'https://kerekparszakuzletbaja.hu/' },
      { '@type': 'ListItem', position: 2, name: 'Kerékpárok', item: 'https://kerekparszakuzletbaja.hu/kerekparok' },
      { '@type': 'ListItem', position: 3, name: data.title, item: `https://kerekparszakuzletbaja.hu/${data.slug}-kerekpar` },
    ],
  };

  return (
    <>
      <Helmet>
        <title>{data.titleSEO}</title>
        <meta name="description" content={data.description} />
        <link rel="canonical" href={`https://kerekparszakuzletbaja.hu/${data.slug}-kerekpar`} />
        <meta property="og:title" content={data.titleSEO} />
        <meta property="og:description" content={data.description} />
        <meta property="og:url" content={`https://kerekparszakuzletbaja.hu/${data.slug}-kerekpar`} />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>

      <main className="page">
        {/* Hero sáv */}
        <section style={{ background: `linear-gradient(135deg, ${data.bg} 0%, #111 100%)`, padding: 'clamp(48px,8vw,96px) 0 clamp(40px,6vw,72px)', marginBottom: 0 }}>
          <div className="container">
            {/* Breadcrumb */}
            <nav style={{ marginBottom: 16, fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>
              <Link to="/" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>Kezdőlap</Link>
              {' / '}
              <Link to="/kerekparok" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>Kerékpárok</Link>
              {' / '}
              <span style={{ color: 'white' }}>{data.title}</span>
            </nav>
            <FadeIn>
              <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(2rem,5vw,3.5rem)', fontWeight: 900, color: 'white', lineHeight: 1.1, marginBottom: 20 }}>
                {data.h1}
              </h1>
              <p style={{ fontSize: 'clamp(1rem,2vw,1.2rem)', color: 'rgba(255,255,255,0.8)', maxWidth: 680, lineHeight: 1.7, marginBottom: 32 }}>
                {data.intro}
              </p>
              <Link
                to={`/kerekparok?kategoria=${data.shopKategoria}`}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: data.color, color: '#000', fontWeight: 700, padding: '14px 28px', borderRadius: 8, textDecoration: 'none', fontSize: 15 }}
              >
                Összes {data.title} megtekintése
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </Link>
            </FadeIn>
          </div>
        </section>

        {/* Termékek */}
        <section style={{ padding: 'clamp(48px,6vw,80px) 0', background: 'var(--bg)' }}>
          <div className="container">
            <h2 className="section-title" style={{ marginBottom: 32 }}>Kiemelt {data.title} modellek</h2>
            {loading ? (
              <div style={{ textAlign: 'center', padding: 48, color: 'var(--text-muted)' }}>Betöltés...</div>
            ) : products.length > 0 ? (
              <div className="product-grid">
                {products.slice(0, 8).map(p => <ProductCard key={p.id} product={p} />)}
              </div>
            ) : (
              <p style={{ textAlign: 'center', color: 'var(--text-muted)', padding: 48 }}>Hamarosan érkeznek a termékek.</p>
            )}
            <div style={{ textAlign: 'center', marginTop: 40 }}>
              <Link
                to={`/kerekparok?kategoria=${data.shopKategoria}`}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 8, border: '2px solid var(--primary)', color: 'var(--primary)', fontWeight: 700, padding: '12px 28px', borderRadius: 8, textDecoration: 'none', fontSize: 15 }}
              >
                Mutasd az összes {data.title}t
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </Link>
            </div>
          </div>
        </section>

        {/* Tartalom szekciók */}
        <section style={{ padding: 'clamp(48px,6vw,80px) 0', background: 'var(--white)' }}>
          <div className="container" style={{ maxWidth: 860 }}>
            {data.sections.map((s, i) => (
              <FadeIn key={i}>
                <div style={{ marginBottom: 48 }}>
                  <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(1.4rem,3vw,2rem)', fontWeight: 700, color: 'var(--text)', marginBottom: 16 }}>{s.h2}</h2>
                  <p style={{ fontSize: '1.05rem', color: 'var(--text-muted)', lineHeight: 1.8 }}>{s.text}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section style={{ padding: 'clamp(48px,6vw,80px) 0', background: 'var(--bg)' }}>
          <div className="container" style={{ maxWidth: 860 }}>
            <h2 className="section-title" style={{ marginBottom: 40 }}>Gyakori kérdések – {data.title}</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {data.faqs.map((f, i) => (
                <FadeIn key={i}>
                  <details style={{ background: 'var(--white)', borderRadius: 12, border: '1px solid var(--border)', padding: '20px 24px', cursor: 'pointer' }}>
                    <summary style={{ fontWeight: 700, fontSize: '1rem', color: 'var(--text)', listStyle: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
                      {f.q}
                      <span style={{ fontSize: 20, color: data.color, flexShrink: 0 }}>+</span>
                    </summary>
                    <p style={{ marginTop: 12, color: 'var(--text-muted)', lineHeight: 1.7, fontSize: '0.97rem' }}>{f.a}</p>
                  </details>
                </FadeIn>
              ))}
            </div>
          </div>
        </section>

        {/* Kapcsolódó kategóriák */}
        <section style={{ padding: 'clamp(32px,5vw,64px) 0', background: 'var(--white)' }}>
          <div className="container">
            <h2 className="section-title" style={{ marginBottom: 28 }}>Kapcsolódó kategóriák</h2>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              {data.related.map(r => (
                <Link
                  key={r.slug}
                  to={`/${r.slug}`}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text)', fontWeight: 600, padding: '12px 24px', borderRadius: 8, textDecoration: 'none', fontSize: 15, transition: 'border-color .2s' }}
                >
                  {r.label}
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </Link>
              ))}
              <Link
                to="/kerekparok"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text)', fontWeight: 600, padding: '12px 24px', borderRadius: 8, textDecoration: 'none', fontSize: 15 }}
              >
                Összes kerékpár
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </Link>
            </div>
          </div>
        </section>

        {/* CTA sáv */}
        <section style={{ background: `linear-gradient(135deg, ${data.bg} 0%, #111 100%)`, padding: 'clamp(48px,6vw,80px) 0', textAlign: 'center' }}>
          <div className="container">
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(1.6rem,4vw,2.6rem)', fontWeight: 800, color: 'white', marginBottom: 16 }}>
              Segítünk választani!
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.05rem', marginBottom: 32, maxWidth: 560, margin: '0 auto 32px' }}>
              Nem tudod melyik modell a legjobb neked? Töltsd ki a kvízünket és 2 perc alatt megkapod a személyre szabott ajánlatot.
            </p>
            <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/kviz" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: data.color, color: '#000', fontWeight: 700, padding: '14px 28px', borderRadius: 8, textDecoration: 'none', fontSize: 15 }}>
                Kerékpár kvíz indítása
              </Link>
              <Link to="/kapcsolat" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'transparent', border: '2px solid rgba(255,255,255,0.5)', color: 'white', fontWeight: 700, padding: '14px 28px', borderRadius: 8, textDecoration: 'none', fontSize: 15 }}>
                Kapcsolatfelvétel
              </Link>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
